import React, { useCallback } from 'react';
import { Box, Text } from '@common-fe/common-fe';
import styled from 'styled-components';

import { Option } from '@/modules/core/components/Menu/menu.types';

const Wrapper = styled(Box)`
  & > svg {
    fill: ${({ theme }) => theme.colors.iconAccent};
  }
`;

interface Props extends Option {
  testId?: string;
  onPick: (url?: string) => void;
  setIsDropdownVisible?: (value: boolean) => void;
}

const MobileSidebarOptionDropdownItem: React.FC<Props> = ({ testId, title, icon, link, url, onPick, setIsDropdownVisible }) => {
  const handleClick = useCallback(() => {
    if (link) {
      window.open(link, '_blank');
      setIsDropdownVisible?.(false);
      return;
    }
    onPick(url);
    setIsDropdownVisible?.(false);
  }, [link, onPick, url, setIsDropdownVisible]);

  return (
    <Wrapper
      data-testId={testId}
      direction="row"
      align="center"
      gap="spacing12"
      pad="spacing16"
      round="container1Round"
      background="module"
      onClick={handleClick}
    >
      {icon}
      <Text data-testId={`${testId}_title`} size="20px" weight={700} color="textBody">
        {title}
      </Text>
    </Wrapper>
  );
};

export default MobileSidebarOptionDropdownItem;
